"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formik = require("formik");
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var InputError = function InputError(_ref) {
  var className = _ref.className,
    name = _ref.name,
    renderAppendAddon = _ref.renderAppendAddon;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched,
    values = _useFormikContext.values;
  var hasError = errors[name] && touched[name];
  if (!hasError) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledInputError, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: name
  }), renderAppendAddon && renderAppendAddon(values[name]));
};
var StyledInputError = _styledComponents["default"].div.withConfig({
  displayName: "InputError__StyledInputError",
  componentId: "sc-1hycyqj-0"
})(["margin-top:4px;color:", ";max-width:fit-content;"], _userflow["default"].colors.monza);
var _default = exports["default"] = InputError;